import { FC } from 'react';
import { Icon } from '@scale/scaleui';
import { AutosaveHook } from 'react-scale/hooks/useAutosave';

type InfoAutosaveProps = { autosave: AutosaveHook<any>; autosaveEnabled: boolean };

export const InfoAutosave: FC<InfoAutosaveProps> = ({ autosaveEnabled, autosave }) => {
  if (!autosaveEnabled) return null;

  if (autosave.isAutosaving) {
    return (
      <div className="flex items-center">
        <Icon icon="loader" size="sm" className="fa-spin" /> Saving...
      </div>
    );
  }

  return null;

  // let secsSinceAutosave: number | undefined = undefined;
  // let minsSinceAutosave: number | undefined = undefined;
  // if (lastAutosaveTime) {
  //   secsSinceAutosave = dateDiff(new Date(), lastAutosaveTime, 'seconds');
  //   if (secsSinceAutosave) minsSinceAutosave = Math.floor(secsSinceAutosave / 60);
  // }

  // const getLastSave = () => {
  //   if (minsSinceAutosave && minsSinceAutosave > 0) {
  //     return `${minsSinceAutosave} ${minsSinceAutosave === 1 ? 'minute' : 'minutes'} ago`;
  //   }
  //
  //   if (secsSinceAutosave && secsSinceAutosave > 5) {
  //     return 'A few seconds ago';
  //   }
  //
  //   return 'Just now!';
  // };
};
